import Board from '@/models/Board'
import Api from '@/api'
import store from '@/store'
import { each, find, findIndex } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    boardDetails: null,
    changelog: {
      data: [],
      meta: {}
    },
    isLoading: true
  },

  mutations: {
    setBoardList(state, boards) {
      each(boards, board => {
        const exist = find(state.list, { id: board.id })
        if (!exist) {
          state.list.push(new Board(board))
        }
      })
    },

    setBoardListMeta(state, meta) {
      state.listMeta = meta
    },

    clearBoardList(state) {
      state.list = []
      state.listMeta = {}
    },

    setBoardDetails(state, board) {
      if (board instanceof Board) {
        state.boardDetails = board
      } else {
        state.boardDetails = new Board(board)
      }
    },

    clearBoardDetails(state) {
      state.boardDetails = null
    },

    setBoardListItemDetails(state, board) {
      const index = findIndex(state.list, { board_id: board.id })
      state.list[index].name = board.name
      state.list[index].location = board.location
      state.list[index].updated_at = board.updated_at
    },

    clearBoardListItemDetails(state, id) {
      const index = findIndex(state.list, { board_id: id })
      state.list.splice(index, 1)
    },
    setChangelog(state, payload) {
      state.changelog.meta = payload.meta
      state.changelog.data = [...state.changelog.data, ...payload.data]
    },
    setLoading(state, payload) {
      state.isLoading = payload
    },
    clearAssets(state) {
      state.boardDetails.assets = []
    }
  },

  actions: {
    async getBoards({ commit }, params) {
      const { data } = await Api.get(
        `users/${store.state.auth.user.id}/scans?page=${params.page}&limit=${
          params.limit
        }`
      )

      commit('setBoardList', data.data)
      commit('setBoardListMeta', data.meta)
    },

    async getBoardDetails({ commit }, id) {
      const { data } = await Api.get(`boards/${id}`)
      commit('setBoardDetails', data.data)
    },

    async scanBoard({ commit, state }, formData) {
      const { data } = await Api.post(
        `/users/${store.state.auth.user.id}/scans?include=site.banner`,
        formData
      )
      commit('setBoardDetails', data.data)
    },

    async getChangelog({ commit }, { id, queryString = '' }) {
      commit('setLoading', true)
      const { data } = await Api.get(
        `boards/${id}/schedules/change-log${queryString}`
      )
      commit('setLoading', false)
      commit('setChangelog', data)
    },

    async createBoard({ commit, state }, formData) {
      const { data } = await Api.post(`boards`, formData)
      commit('setBoardDetails', data.data)
    },

    async updateBoard({ commit, state }, formData) {
      const { data } = await Api.put(`boards/${formData.board_id}`, formData)
      commit('setBoardDetails', data.data)
    },

    async uploadAsset({ commit, state }, payload) {
      const { data } = await Api.post(
        `/boards/${payload.boardId}/upload-assets`,
        payload.form
      )
      commit('setBoardDetails', data.data)
    },
    async removeAsset({ commit, state }, payload) {
      await Api.delete(
        `/boards/${payload.boardId}/upload-assets/${payload.assetId}`
      )
      commit('clearAssets')
    },

    async deleteBoard({ commit, state }, id) {
      await Api.delete(`boards/${id}`)
      commit('clearBoardListItemDetails', id)
    },

    async archiveBoard({ commit, state }, id) {
      await Api.post(`boards/${id}/archive`)
    },

    async updateBoardSchedule({ commit, state }, formData) {
      const { data } = await Api.post(
        `boards/${state.boardDetails.board_id}/schedules/update`,
        formData
      )
      state.boardDetails.schedules = data.data
    },

    async groupBoardSchedule({ commit, state }, formData) {
      const { data } = await Api.post(
        `boards/${state.boardDetails.board_id}/schedules/group`,
        formData
      )
      for (let i = 0; i < data.data.length; i++) {
        let index = findIndex(state.boardDetails.schedules, {
          schedule_id: data.data[i].schedule_id
        })
        state.boardDetails.schedules[index] = data.data[i]
      }
    },

    async ungroupBoardSchedule({ commit, state }, formData) {
      const { data } = await Api.post(
        `boards/${state.boardDetails.board_id}/schedules/ungroup/${
          formData.group_id
        }`
      )
      for (let i = 0; i < data.data.length; i++) {
        let index = findIndex(state.boardDetails.schedules, {
          schedule_id: data.data[i].schedule_id
        })
        state.boardDetails.schedules[index] = data.data[i]
      }
    },

    async updateRCDProtected({ commit, state }, payload) {
      try {
        const { data } = await Api.post(
          `boards/${
            state.boardDetails.board_id
          }/schedules/update-rcd-protected`,
          payload
        )
        for (let i = 0; i < data.data.length; i++) {
          let index = findIndex(state.boardDetails.schedules, {
            schedule_id: data.data[i].schedule_id
          })
          state.boardDetails.schedules[index] = data.data[i]
        }
      } catch ({ response: { data } }) {}
    }
  }
}
